module.exports = __webpack_public_path__ + "static/media/steve-1986.e354820c.jpg";